// extracted by mini-css-extract-plugin
export var loadingSpinner = "_3s-1";
export var standaloneTable = "_3s-0";